import { useTranslation } from 'react-i18next';
import { ReactComponent as PenIcon } from 'assets/icons/pen.svg';
import { ReactComponent as TrashIcon } from 'assets/icons/tresh.svg';
import Button from 'components/Button/Button';
import EditTopicName from 'components/EditTopicName/EditTopicName';
import IconButton from 'components/IconButton/IconButton';
import KeywordItem from 'components/KeywordItem/KeywordItem';
import Tooltip from 'components/Tooltip/Tooltip';
import { BUTTON_VARIANT } from 'constants/interfaces';

import type ISubtopicRow from '../interfaces/ISubtopicRow';

import styles from '../scss/SubtopicRow.module.scss';

function SubtopicRow({
  subTopic,
  openEditSubTopicField,
  selectedItem,
  text,
  onChangeText,
  onUpdateSubtopic,
  onCancel,
  openKeywordsField,
  onOpenFieldKeyWords,
  onSaveKeyWords,
  onDeleteKeyword,
  onEditSubtopicName,
  onDeleteItem,
}: Readonly<ISubtopicRow>) {
  const { t } = useTranslation();

  return (
    <div className={styles.subtopicRow} key={[subTopic.id, subTopic.title].join('_')}>
      <span className={styles.subtopicCell}>
        {openEditSubTopicField && selectedItem === subTopic.id
          ? (
            <EditTopicName
              text={text}
              placeholder={t('standards.typeHere')}
              onChangeText={onChangeText}
              onSave={onUpdateSubtopic}
              onCancel={onCancel}
              saveTitle={t('common.save')}
              cancelTitle={t('common.cancel')}
            />
          ) : <p>{subTopic.title}</p>}
      </span>
      <div className={styles.subtopicCell}>
        {openKeywordsField && selectedItem === subTopic.id
          ? (
            <div className={styles.editWrapper}>
              <EditTopicName
                text={text}
                placeholder={t('standards.typeHere')}
                onChangeText={onChangeText}
                onSave={onSaveKeyWords}
                onCancel={onCancel}
                saveTitle={t('common.save')}
                cancelTitle={t('common.cancel')}
                keyWordsType
              />
            </div>
          )
          : (
            <Button
              title={t('standards.addKeySearch')}
              variant={BUTTON_VARIANT.ghost}
              onClick={() => onOpenFieldKeyWords(subTopic.id || -1)}
              className={styles.buttonAdd}
            />
          )}
        <div className={styles.keywordsWrapper}>
          {subTopic.keywords.map((keyword, index) => (
            <KeywordItem
              key={[keyword, index].join('_')}
              keyword={keyword}
              onRemove={() => onDeleteKeyword(subTopic.id || -1, keyword)}
            />
          ))}
        </div>
      </div>
      <div className={styles.subtopicCell}>
        <Tooltip className={styles.tooltip} hint={t('standards.editName')}>
          <IconButton
            className={styles.editIcon}
            icon={<PenIcon />}
            onClick={() => onEditSubtopicName(subTopic.id || -1)}
          />
        </Tooltip>
        <Tooltip className={styles.tooltip} hint={t('standards.delete')}>
          <IconButton
            className={styles.deleteIcon}
            icon={<TrashIcon />}
            onClick={() => onDeleteItem(subTopic.id || -1, true)}
          />
        </Tooltip>
      </div>
    </div>
  );
}

export default SubtopicRow;
